import {getBeacons, TXY} from "@ui/api/features"
import service from "@ui/services/features/BeaconService"
import {LayerId} from "@ui/services/features"
import aggregation from "@ui/services/features/Aggregation"
import {Feature, TFeatureConstructorParams} from "./feature"

type TBeaconConstructorParams = TFeatureConstructorParams

export class Beacon extends Feature {

  constructor(params:  TBeaconConstructorParams) {
    super(params)
  }

  async load(coords: TXY): Promise<void> {
    const beacons = await getBeacons(coords)
    aggregation.addAggregations(beacons.aggregations)
    service.addBeacons(beacons.lateral, LayerId.BCNLAT)
    service.addBeacons(beacons.special_purpose, LayerId.BCNSPP)
  }

  toggle(isVisible: boolean) {
    service.toggleLayer(isVisible)
  }
}
